<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.badges', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex justify-end">
            <AppButton element="InertiaLink" :href="meta.links.requests_index">
                {{ $t('messages.pending_requests') }}: {{ meta.info.pendingRequests }}
            </AppButton>
        </div>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <span class="sr-only">{{ $t('messages.image') }}</span>
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.name') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $tc('messages.students', 2) }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <span class="sr-only">{{ $t('messages.actions') }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(badge, index) in badges"
                                :key="badge.id"
                            >
                                <td class="px-6 py-4 text-sm leading-5 text-gray-500">
                                    <ZoomableImage :src="badge.image_path">
                                        <div class="w-16 h-16 lg:w-20 lg:h-20">
                                            <img
                                                class="w-16 h-16 rounded-full lg:w-20 lg:h-20"
                                                :class="badge.obtained ? 'bg-indigo-400' : 'bg-indigo-600 opacity-25'"
                                                :src="badge.image_path"
                                                alt=""
                                            />
                                        </div>
                                    </ZoomableImage>
                                </td>
                                <td class="px-6 py-4 text-sm leading-5 text-gray-500">
                                    <div class="font-semibold text-gray-600">
                                        {{ badge.name }}
                                    </div>
                                    <div>
                                        {{ badge.description }}
                                    </div>
                                    <div v-if="badge.badgeRequest.status === 'requested'">
                                        <BadgePill color="indigo">
                                            {{ $t('messages.has_already_been_requested') }}
                                        </BadgePill>
                                    </div>
                                    <div v-if="badge.badgeRequest.status === 'rejected'">
                                        <BadgePill color="yellow">
                                            {{ $t('messages.rejected') }}
                                        </BadgePill>
                                        <div v-if="badge.links.badge_request_edit">
                                            <AppButton :href="badge.links.badge_request_edit">
                                                {{ $t('messages.request') }}
                                            </AppButton>
                                        </div>
                                    </div>
                                    <div v-else-if="badge.links.badge_request_create">
                                        <AppButton :href="badge.links.badge_request_create">
                                            {{ $t('messages.request') }}
                                        </AppButton>
                                    </div>
                                    <ProgressBar
                                        v-if="badge.is_automatic"
                                        :percent="badge.percent"
                                        color="indigo"
                                        height="sm"
                                        :show-text="false"
                                        class="mt-1 w-40"
                                    />
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    {{ badge.obtained_percent }}%
                                </td>
                                <td
                                    class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500"
                                    v-if="badge.obtained_percent"
                                >
                                    <InertiaSquareLinkButton action="show" :href="badge.links.show" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import ProgressBar from '@/components/Gamification/ProgressBar.vue';
import BadgePill from '@/components/BadgePill.vue';
import AppButton from '@/components/AppButton.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import ZoomableImage from '@/components/ZoomableImage.vue';

export default {
    components: {
        ZoomableImage,
        InertiaSquareLinkButton,
        PanelPage,
        ProgressBar,
        BadgePill,
        AppButton,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'badges'],
};
</script>
